import { Currency } from '@/core/currency/interfaces';

const ERN: Currency = {
    name: 'Eritrean Nakfa',
    demonym: 'Eritrean',
    majorSingle: 'Nakfa',
    majorPlural: 'Nakfa',
    codeNumeric: '232',
    symbol: 'Nkf',
    symbolNative: 'ناكفا',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'ERN',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default ERN;
